import { PapercardBenefitCarousel } from "./PapercardBenefitCarousel";
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";

const benefitCarousel = new PapercardBenefitCarousel(eventQBus);
benefitCarousel.init();
